<template>
    <h1>Integrations</h1>
    <p>
        Configure integrations with external services for your Stek
        {{ stek?.name }}.
    </p>
    <Spinner v-if="isLoadingSteks" />
    <IntegrationsPanel v-else-if="stek?.identity" />
</template>

<script setup lang="ts">
import IntegrationsPanel from "@/components/integrations/IntegrationsPanel.vue";
import { useStekManager } from "@/composables/stek-manager";
import Spinner from "@/shared/Spinner.vue";

const { stek, isLoadingSteks } = useStekManager();
</script>
